<template>
  <router-view></router-view>
</template>

<script>

const now = Math.floor(Date.now() / 1000);
export default {
  name: 'App',
  mounted() {
    if (this.$api.payload !== null) {
     this.$api.handle = setTimeout(() => {
        this.$api.token = null;
        this.$api.login()
      }, (this.$api.payload.exp - now) * 1000);
    }
  },
  beforeDestroy() {
    if (this.$api.handle !== null) {
      clearTimeout(this.$api.handle);
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
